export function createArrayPayloadFromBlind(blind, quantity) {
    if (quantity <= 1) return blind
    let arrayOfBlinds = []
    for (let i = 0; i < quantity; i++) {
        let tempBlind = JSON.parse(JSON.stringify(blind))
        tempBlind.order = tempBlind.order + i
        arrayOfBlinds.push(tempBlind)
    }
    return arrayOfBlinds
}